module.exports = __webpack_public_path__ + "static/media/flc.2880c5b0.png";